import { Protocol, RecordDraft } from '../types/sharedTypeImpl.ts';


export function getCriticalValuesMissing(record: RecordDraft, protocol: Protocol): boolean {
    const criticalValuesMissing = record.parts.some(part => {
        return part.positionValues.some((positionValue, index) => {
            // The position type is assumed to be measurement, since only those positions can be critical
            const isCritical = protocol.positions[index].isCritical ?? false;
            const isValueMissing = positionValue.value == null || positionValue.value === '';
            return isCritical && isValueMissing;
        });
    });
    return criticalValuesMissing;
}
